import {BotId} from "../../global/models/models";
import {
    WELCOME_TEXT_INTRO,
    DZT_WELCOME_TEXT_INTRO,
    FORM_WELCOME_TEXT_INTRO,
} from "../../global/variables";

export function getWelcomeText(bot: BotId, type?: string): string {
    switch (bot) {
        case 'KUG':
            return (
                WELCOME_TEXT_INTRO +
                '<p>Ich helfe Ihnen gerne Ihr <b>Kurzarbeitergeld (KUG) zu berechnen</b> und <b>Fragen zum Thema zu beantworten</b>. Ich kann Ihnen aber <b>auch Fragen zu vielen anderen Themen</b> der BA beantworten.</p>'
            )
        case 'ALG':
            return (
                WELCOME_TEXT_INTRO +
                '<p>Gerne beantworte ich Ihre Fragen rund um <b>Beratungs-, Geld und Förderleistungen</b> der Agentur für Arbeit.</p>'
            )
        case 'BGELD':
            return (
                WELCOME_TEXT_INTRO +
                '<p>Gerne beantworte ich Ihre Fragen zum Themenbereich Bürgergeld oder helfe Ihnen, Ihren Anspruch auf Bürgergeld zu prüfen.</p>'
            )
        case 'FAMKA':
            return (
                WELCOME_TEXT_INTRO +
                '<p>Ich beantworte gerne Ihre <b>Fragen zum Thema Kindergeld sowie zum Kinderzuschlag</b> und helfe Ihnen einen Überblick über die Voraussetzungen von Kindergeld zu bekommen.</p>'
            )
        case 'SAS':
            return (
                WELCOME_TEXT_INTRO +
                '<p>Ich beantworte gerne Deine <b>Fragen zum Thema Ausbildung, Studium & Berufe</b> und helfe Dir, einen Überblick über die verschiedenen Möglichkeiten nach Deinem Schulabschluss zu bekommen.</p>'
            )
        case "FORM":
            switch (type) {
                case "MAIN_DE": {
                    return (
                        FORM_WELCOME_TEXT_INTRO +
                        "<p> Auf dieser Seite helfe ich Menschen, die vor dem Krieg in der Ukraine geflohen sind und sich zur Arbeitssuche und Berufsausbildung in Deutschland beraten lassen möchten.<br><br>" +
                        "Ich helfe Ihnen gern den <b>benötigten Fragebogen für die Berufsberatung</b> in Ihrem zuständigen Jobcenter auszufüllen.</p>" +
                        ""
                    );
                }
                case "MAIN_UA": {
                    return (
                        "<p>Привіт!<br><br>Я чат-бот Федерального агентства зайнятості. На цій сторінці я допомагаю людям, які втекли від війни в Україні і хочу надати поради щодо пошуку роботи та професійного навчання у Німеччині. Я з радістю допоможу Вам заповнити анкету, необхідну для отримання консультації щодо кар’єри у вашому місцевому центрі зайнятості.</p>" +
                        ""
                    );
                }
                case "FORM_DE": {
                    return "<p>5 Schritte zum ausgefüllten Fragebogen:</p>";
                }
                case "FORM_UA": {
                    return "<p>5 кроків до заповненої анкети:</p>";
                }
                default:
                    return "";
            }
        case 'INKASSO':
            return (
                FORM_WELCOME_TEXT_INTRO +
                '<p>Sie befinden sich derzeit auf den Seiten des Inkasso-Service.</br>Hier finden Sie hilfreiche Informationen zu einigen Themen, welche wir anhand der häufigsten Fragestellungen für Sie zusammengestellt haben.</p>'
            )
        case 'PINK':
            return (
                FORM_WELCOME_TEXT_INTRO +
                '<p>Ich kann Ihnen helfen, einen Überblick über Ihr Profil zu erlangen. Gerne beantworte ich Ihre Fragen zu verschiedenen Themen im angemeldeten Bereich des Portals der Bundesagentur für Arbeit.</p>'
            )
        case 'STARTSEITE':
            return (
                DZT_WELCOME_TEXT_INTRO +
                '<p><b>Hinweis:</b> Ich kann Ihnen keine Fragen zu Ihrer lokalen Agentur und persönlichen Fällen beantworten.</p>'
            )
        case 'WAU':
            return (
                WELCOME_TEXT_INTRO +
                '<p>Ich beantworte gerne Deine <b>Fragen zum Thema Weiterbildung, Aufstiegsfortbildung und Umschulung</b> und helfe Dir, einen Überblick über die verschiedenen Möglichkeiten nach Deinem Schulabschluss zu bekommen.</p>'
            )
        default:
            return ''
    }
}
